import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import {
  fetchAllNotifications,
  fetchUnreadNotificationCount,
  markAllNotificationReadApi,
  markNotificationRead,
} from '../../api/notifications-api';
import { setCookie } from 'utils/cookies-util';

const initialState = {
  data: [],
  pagination: {},
  unreadCount: 0,
  loading: true,
  markLoading: false,
};

export const fetchNotifications = createAsyncThunk('notifications/user', async (paramsObj = {}) => {
  const updatedObj = {
    ...paramsObj,
    'q[s]': 'created_at desc',
  };
  try {
    const res = await fetchAllNotifications(updatedObj);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const fetchUnreadCount = createAsyncThunk('notifications/unread', async (onSuccess = () => {}) => {
  try {
    const res = await fetchUnreadNotificationCount();
    if (res?.current_cache_key || res?.tenant_cache_key) onSuccess(res?.current_cache_key, res?.tenant_cache_key);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const markNotification = createAsyncThunk('notifications/markread', async (data = {}) => {
  try {
    const res = await markNotificationRead(data?.id, data?.data);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const markAllNotificationsRead = createAsyncThunk('notifications/markreadall', async () => {
  try {
    const res = await markAllNotificationReadApi();
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const NotificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        if (action?.payload?.meta?.pagination?.page === 1) {
          state.data = action?.payload?.data || [];
        } else {
          state.data = [...(state.data || []), ...(action?.payload?.data || [])];
        }
        state.pagination = action?.payload?.meta?.pagination || {};
        state.loading = false;
      })
      .addCase(fetchNotifications.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchUnreadCount.fulfilled, (state, action) => {
        state.unreadCount = action?.payload?.count || 0;
        setCookie('cache-key', JSON.stringify(action?.payload?.current_cache_key));
        setCookie('tenant-key', JSON.stringify(action?.payload?.tenant_cache_key));
      })
      .addCase(markNotification.fulfilled, (state, action) => {
        state.unreadCount = !!state.unreadCount ? state.unreadCount - 1 : 0;
        state.data = state?.data?.map((notification) =>
          notification?.id == action.meta?.arg?.id ? { ...notification, is_read: true } : notification,
        );
      })
      .addCase(markAllNotificationsRead.pending, (state) => {
        state.markLoading = true;
      })
      .addCase(markAllNotificationsRead.fulfilled, (state) => {
        state.unreadCount = 0;
        state.data = state?.data?.map((notif) => ({ ...notif, is_read: true }));
        state.markLoading = false;
      })
      .addCase(markAllNotificationsRead.rejected, (state) => {
        state.markLoading = false;
      });
  },
});

export default NotificationsSlice.reducer;
